import { NumericAggregation } from "@/shared/domain/metrics";

/**
 * Title for a dashboard card, e.g. "mean of battery_voltage". Shared by the
 * chart card and the trend tile so both render the same schema. The
 * aggregation token is rendered verbatim (lowercase, as stored).
 *
 * `aggregation` is absent exactly for a RAW chart card
 * ({@link RawChartCardConfig}), which applies no aggregation function: pass
 * the card's own `aggregation` and the union picks the title. There is no
 * token to put in front of the metric in that case, so the title names what
 * the card actually plots — every value, unaggregated.
 */
export function getCardTitle(
  metricName: string,
  aggregation: NumericAggregation | undefined,
): string {
  return aggregation === undefined
    ? `all values of ${metricName}`
    : `${aggregation} of ${metricName}`;
}
